import React from 'react'

interface TightArrowIconProps extends React.SVGProps<SVGSVGElement> {}

const TightArrowIcon = (props: TightArrowIconProps) => (
  <svg
    width={8}
    height={5}
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8035 0.191259C7.54087 -0.066788 7.11877 -0.0630722 6.86073 0.199559L4.00198 3.10909L1.14235 0.20086C0.884205 -0.0616744 0.46211 -0.0652313 0.199576 0.192915C-0.0629586 0.451061 -0.066516 0.873156 0.19163 1.13569L3.43169 4.43082C3.74524 4.74971 4.25932 4.74961 4.57276 4.43061L7.8118 1.13403C8.06985 0.871401 8.06613 0.449307 7.8035 0.191259Z"
      fill={props.fill ?? "#111"}
    />
  </svg>
)

export default TightArrowIcon
